<template>
    <u-btn-outlined-tile v-bind="$attrs" color="grey lighten-3" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-btn-outlined-tile>
</template>

<script>
import UBtnOutlinedTile from "@/components/publish/styles/buttons/u-btn-outlined-tile.vue";

export default {
    props: {},
    components: {
        UBtnOutlinedTile,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
